/**
 * @Copyright (c) 2022 DigiNet
 * @author TRANGHOANG
 * @create 10/1/2022
 * @Example
 */


import { delay } from 'redux-saga';
import { cancel, take, takeLatest } from 'redux-saga/effects';
import Api from '../../../services/api';
import { types } from './W39F3040_actions';
import Config from '../../../config';

export default function W39F3036Sagas() {
    return [
        watchGetFormData(),
        watchGetGroupDuty(),
        watchLoadTreeList(),
        watchLoadFilter(),
        watchExportExcel(),
    ];
}

export function* getFormData(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w39f3040/load-form', data.params);
        if (response?.data) {
            data.cb && data.cb(null, response.data);
        } else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('getFormData w39f3040 error');
    }
}
export function* watchGetFormData() {
    while (true) {
        const watcher = yield takeLatest(types.W39F3040_LOAD_FORM, getFormData);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

export function* getCbGroupDuty(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w09f1201/load-group', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('get list user error');
    }

}
export function* watchGetGroupDuty() {
    while (true) {
        const watcher = yield takeLatest(types.W39F3040_GET_GROUP_DUTY, getCbGroupDuty);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}
export function* loadTreeList(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w39f3040/load-tree-list', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('load tree list error');
    }

}
export function* watchLoadTreeList() {
    while (true) {
        const watcher = yield takeLatest(types.W39F3040_LOAD_TREELIST, loadTreeList);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}
export function* loadFilter(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w39f3040/load-filter', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data)
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('load filter error');
    }

}
export function* watchLoadFilter() {
    while (true) {
        const watcher = yield takeLatest(types.W39F3040_LOAD_FILTER, loadFilter);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}

function checkUrlFileName(filename) {
    //if file name had special character return valid data
    const specialChar = filename.search("UTF-8");
    if (specialChar !== -1) {
        const reFileName = filename.slice(specialChar + 7, filename.length);
        return filename = decodeURIComponent(reFileName);
    }
    return filename; // else return original data
}

export function* exportExcel(data) {
    try {
        yield delay(300);
        const response = yield Api.putExport('/w39f3040/excel-export', data.params);
        if (response && response.ok) {
            let _res = null;
            if (response.type === "json") {
                _res = yield response.data.json();
                if (_res && _res.data) {
                    data.cb && data.cb(null, _res.data);
                } else {
                    data.cb && data.cb(_res, null)
                }
            } else {
                const content = yield response.data.blob();
                const datetime = new Date().getTime();
                const _fileName = response.filename ? checkUrlFileName(response.filename) : "data-export-hr-" + datetime + '.xls';
                _res = {
                    fileName: _fileName,
                    fileExt: Config.helpers.getExtFile(_fileName),
                    URL: URL.createObjectURL(content),
                };
                if (_res && _res.URL) {
                    data.cb && data.cb(null, _res);
                } else {
                    data.cb && data.cb(_res, null);
                }
            }
        }
        else {
            data.cb && data.cb(response, null)
        }
    }
    catch (e) {
        console.log('export excel error');
    }

}
export function* watchExportExcel() {
    while (true) {
        const watcher = yield takeLatest(types.W39F3040_EXPORT_EXCEL, exportExcel);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }
}